module.exports = __webpack_public_path__ + "c13d543ab6cb1021771175bd2de49214.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/GoldenCityapp.jpg
// module id = 846
// module chunks = 0